import { Menu } from '@mui/icons-material'
import { AppBar, IconButton, Stack, Toolbar, useMediaQuery, useTheme } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { FormsActions, FormsSelector } from '../../store/forms'
import { ButtonIcon, SippLogo } from '../icons'
import { AddressSearchForm } from '../AddressSearchForm'
import { useNavigate } from 'react-router'
import { ContainedButton } from '../Button'

export const Header = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const formId = 'navigationSidebar'
  const formValues = useSelector((state: RootState) => FormsSelector.getFormValues(state, formId))
  const { open = false } = formValues

  const baseStyle = {
    height: 68,
    background: isMobile ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.9)',
    backdropFilter: isMobile ? 'blur(10px)' : undefined,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,

  }

  const handleDrawerToggle = () => {
    dispatch(FormsActions.setValue({ id: 'navigationSidebar', open: !open }))
  }

  return (
    <AppBar position="static" sx={baseStyle} elevation={0}>
      <Toolbar sx={{ py: 1, height: '100%' }}>
        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <IconButton aria-label="open drawer" onClick={handleDrawerToggle} edge="start">
              <Menu />
            </IconButton>
            <SippLogo sx={{ fontSize: isMobile ? '2.5rem' : '3rem', ml: isMobile ? 0 : 1 }} />
          </Stack>

          {!isMobile && <AddressSearchForm />}
          {/* {!isMobile && <ZipCodeForm />} */}
  
          <ContainedButton
            size="large"
            onClick={() => navigate('/test-strip')}
            startIcon={<ButtonIcon />}
            sx={{
              py: 1,
              px: 1.5,
            }}
          >
            Test your water
          </ContainedButton>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}
